<template>
  <div>
    <label
      class="text-background-fg/70 mb-1 block text-left text-xs font-medium"
    >
      {{ label }}
    </label>
    <BaseSelect
      :model-value="inputValue"
      :options="computedOptions"
      @update:model-value="setModelValue"
    />

    <template v-if="hasError">
      <p class="text-error mt-1 text-xs font-medium">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

import type { Option } from "@/composables/options/options"

const props = defineProps<{
  name: string
  options: Option[]
  label?: string
  disableNull?: boolean
}>()

const {
  value: inputValue,
  errorMessage,
  setValue,
} = useField<(typeof props)["options"][number]["value"]>(
  props.name,
  undefined,
  {
    initialValue: undefined,
  }
)

const hasError = computed(() => !!errorMessage.value)

const setModelValue = (
  newValue: (typeof props)["options"][number]["value"]
) => {
  setValue(newValue)
}

const computedOptions = computed(() => [
  ...(props.disableNull
    ? []
    : [{ value: null, label: "---" }]),
  ...props.options,
])
</script>
